export const PLATFORM_ANONYMOUS_ENDPOINT = "GetTokenBySiteId";
export const SEAMLESS_ANONYMOUS_ENDPOINT = "anonymous";
//# sourceMappingURL=requestService.js.map